import React, { useState, useEffect, useCallback } from 'react';
import Select from 'react-select';
import { Button, Container, Row, Col, Alert, Form } from 'react-bootstrap'

import Tabella from './Tabella';
import { getDatiTabella } from './handlers/datiTabellaHandler'
import { buildUrl } from "./helper/handler"
import { SpinnerComp } from './helper/spinner';
import { Settimane, getStartOfWeek, getEndOfWeek } from './helper/settimane';
import { getFromApi } from './utilities/NetUtilities';

const getUrl = (url, inizio, fine, zona, nome, tipo, tutti) => {
    var paramsObject = {
        organizzazione: nome,
        tipo: tipo,
        start: inizio,
        end: fine,
        zona: zona,
        tutti: tutti
    };
    return buildUrl(url, paramsObject);
};

function TabellaGenerale (props) {
    const [datiTabellaFatturato, setDatiTabellaFatturato] = useState([]);
    const [datiTabellaMedia, setDatiTabellaMedia] = useState([]);
    const [datiTabellaVariazione, setDatiTabellaVariazione] = useState([]);
    const [datiTabellaMedia730, setDatiTabellaMedia730] = useState([]);
    const [datiRiepilogoGenerale, setDatiRiepilogoGenerale] = useState([]);
    const [loading, setLoading] = useState(false);
    const [numSettimanaInizio, setNumSettimanaInizio] = useState("1");
    const [numSettimanaFine, setNumSettimanaFine] = useState("53");
    const [zona, setZona] = useState([]);
    const [optionsZone, setOptionsZone] = useState([]);
    const [selectedOptionSettimanaInizio, setSelectedOptionSettimanaInizio] = useState({ label: `settimana 1 (${getStartOfWeek(1)} - ${getEndOfWeek(1)})`, value: "1" });
    const [selectedOptionSettimanaFine, setSelectedOptionSettimanaFine] = useState({ label: `settimana 53 (${getStartOfWeek(53)} - ${getEndOfWeek(53)})`, value: "53" });
    const [selectedOptionZona, setSelectedOptionZona] = useState(null);
    const [nomeOrganizzazione, setNomeOrganizzazione] = useState("");
    const [tipoOrganizzazione, setTipoOrganizzazione] = useState("");
    const [message, setMessage] = useState({});
    const [emptyData, setEmptyData] = useState("");
    const [checked, setChecked] = useState(false);

    const connessioneBack = useCallback((inizio, fine, zona, nome, tipo, tutti) => {
        const okAction = (data) => {
            setLoading(false);
            if (data.emptytable) {
                setEmptyData(data.emptytable[0]);
            } else {
                const {
                    datiTabellaFatturato,
                    datiTabellaMedia,
                    datiTabellaVariazione,
                    datiTabellaMedia730,
                    datiRiepilogoGenerale,
                    optionsZone
                } = getDatiTabella(
                    data,
                    props.numTabella,
                    props.nome,
                    props.riepilogogenerale, inizio, fine, zona, nome, tipo, tutti
                );
                setDatiTabellaFatturato(datiTabellaFatturato);
                setDatiTabellaMedia(datiTabellaMedia);
                setDatiTabellaVariazione(datiTabellaVariazione);
                setDatiTabellaMedia730(datiTabellaMedia730);
                console.log("datiRiepilogoGenerale", props.riepilogogenerale)
                setDatiRiepilogoGenerale(datiRiepilogoGenerale);
                setOptionsZone(optionsZone);
                if (data.warning) {
                    setLoading(false);
                    setMessage({ tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione });
                }
            }
        };
        const nokAction = (data) => {
            setLoading(false);
            setMessage({ tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione });
        };
        const url = getUrl(props.url, inizio, fine, zona, nome, tipo, tutti);
        console.log("url", url)
        getFromApi(url, okAction, nokAction);
    }, [props.nome, props.numTabella, props.riepilogogenerale, props.url]);

    const allYears = () => {
        setLoading(true);
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        connessioneBack("1", "53", "", organizzazioneMap.nome, organizzazioneMap.tipo, !checked);
        setChecked(!checked);
    };

    useEffect(() => {
        setLoading(true);
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        setNomeOrganizzazione(organizzazioneMap.nome);
        setTipoOrganizzazione(organizzazioneMap.tipo);
        if (organizzazioneMap) {
            connessioneBack("1", "53", "", organizzazioneMap.nome, organizzazioneMap.tipo, false);
        }
    }, [connessioneBack]);

    const handleSettimaneInizio = (event) => {
        const inizio = event.value;
        setNumSettimanaInizio(inizio);
        setSelectedOptionSettimanaInizio(event);
    };

    const handleSettimaneFine = (event) => {
        const fine = event.value;
        setNumSettimanaFine(fine);
        setSelectedOptionSettimanaFine(event);
    };

    const handleZone = (event) => {
        const zone = event.map(element => element.value);
        setZona(zone);
        setSelectedOptionZona(event);
    };

    const handleFiltri = () => {
        setLoading(true);
        connessioneBack(numSettimanaInizio, numSettimanaFine, zona, nomeOrganizzazione, tipoOrganizzazione, checked);
    };

    if (loading) {
        return <SpinnerComp />;
    }

    return (
        <div className='main' role='main'>
            <Container fluid>
                <Alert variant={message.tipo} id="message" >
                    {message.descrizione}
                </Alert>
                <h1 id="titolo" className="d-flex justify-content-center mb-5">
                    {props.titolo} ({nomeOrganizzazione.toLowerCase()}/{tipoOrganizzazione.toLowerCase()})</h1>
                <Row className='filtri'>
                    <Col lg={3}>
                        <p className="font-weight-bold">inizio</p>
                        <Select value={selectedOptionSettimanaInizio} className="select" id="inizio"
                            onChange={handleSettimaneInizio} options={Settimane} aria-label='numero settimana inizio' />
                    </Col>
                    <Col lg={3}>
                        <p className="font-weight-bold">fine</p>
                        <Select value={selectedOptionSettimanaFine} className="select" id="fine"
                            onChange={handleSettimaneFine} options={Settimane} aria-label='numero settimana fine' />
                    </Col>
                    <Col lg={3}>
                        <p className="font-weight-bold">zona</p>
                        <Select value={selectedOptionZona} className="select" isMulti id="zona"
                            onChange={handleZone} options={optionsZone} aria-label='zone' />
                    </Col>

                    <Col lg={1}>
                        <Button className='btnGenerale' variant="flat sb-filtri" onClick={handleFiltri} size='sm' id="filtra">conferma</Button>
                        {/* <Button className='btnGenerale' variant="flat sb-filtri" size="sm" onClick={this.allYears}>TUTTI</Button> */}

                    </Col>
                    <Col lg={2}>
                        <Form.Check
                            inline
                            checked={checked}
                            className='ml-3 allYearsCheckbox allyear'
                            type="checkbox"
                            id="default-checkbox"
                            label="mostrare tutti gli anni"
                            onChange={e => allYears(e)} />
                    </Col>

                </Row>
                {emptyData !== "" ? <div className="space m-5">
                    <h2 style={{ marginLeft: "70px" }}>{emptyData}</h2></div> : <>
                    {datiRiepilogoGenerale.map((dati, key) => (
                        <div key={key} className="divTabel mt-5">
                            {dati.button}
                            <Tabella rows={dati.rows} intestazione={dati.intestazione}
                                open={true} nomeTabella={dati.nome} fixed={false} specialeTitle="titileZIndex" />
                        </div>
                    ))}
                    {datiTabellaFatturato.map((dati, key) => (
                        <div key={key} className="divTabel">
                            {dati.button}
                            <Tabella rows={dati.rows} intestazione={dati.intestazione}
                                open={true} nomeTabella={dati.nome} fixed={true} />
                        </div>
                    ))}
                    {datiTabellaMedia.map((dati, key) => (
                        <div key={key} className="divTabel">
                            {dati.button}
                            <Tabella rows={dati.rows} intestazione={dati.intestazione}
                                open={true} nomeTabella={dati.nome} fixed={true} />
                        </div>
                    ))}
                    {datiTabellaMedia730.map((dati, key) => (
                        <div key={key} className="divTabel">
                            {dati.button}
                            <Tabella rows={dati.rows} intestazione={dati.intestazione}
                                open={true} nomeTabella={dati.nome} fixed={true} />
                        </div>
                    ))}
                    {datiTabellaVariazione.map((dati, key) => (
                        <div key={key} className="divTabel">
                            {dati.button}
                            <Tabella rows={dati.rows} intestazione={dati.intestazione}
                                open={true} nomeTabella={dati.nome} fixed={true} />
                        </div>
                    ))}
                </>}
            </Container>
        </div>
    )
}

export default TabellaGenerale